/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "DataPointManagerCodenames-prod",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:69415447-5713-4437-b0c9-af9323380fd3",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_SCqEZT1or",
    "aws_user_pools_web_client_id": "1m76mm623j3fk21kapq7tpt6gl",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "dataPointManagerAPI",
            "endpoint": "https://i6djzerqjf.execute-api.eu-west-2.amazonaws.com/prod",
            "region": "eu-west-2"
        }
    ],
    "aws_content_delivery_bucket": "datapointmanager-20200730134620-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "eu-west-2",
    "aws_content_delivery_url": "https://d3jr2kwzau0k.cloudfront.net"
};


export default awsmobile;
